import {
  UnassignCompetencyFromRoleDocument,
  UnassignCompetencyFromRoleMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUnassignCompetencyFromRole = () => {
  const [mutate] = useMutation(UnassignCompetencyFromRoleDocument, {
    extractorFn: (data: UnassignCompetencyFromRoleMutation) =>
      data.jobCatalogMutations.unassignCompetencyJobcatalogRole,
  })

  const unassignCompetencyFromRole = (id: string, competencyId: string) => {
    return mutate({ variables: { id, competencyId } })
  }

  return unassignCompetencyFromRole
}

export default useUnassignCompetencyFromRole
